import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../styles/movieList.css';
import MovieReturn from '../components/movieReturn';
import { Link } from 'react-router-dom';


const MovieList = () => {
  const [movies, setMovies] = useState([]);
  const imageBaseUrl = 'https://image.tmdb.org/t/p/w500';


  useEffect(() => {
    
    const fetchMovies = async () => {
      try {
        const apiKey = process.env.API;
        const response = await axios.get(`https://api.themoviedb.org/3/movie/popular?api_key=133b03fa38dce6887c1086a85641ce9a&language=en-US&page=1`);
        setMovies(response.data.results);
      } catch (error) {
        console.error("Error fetching movies: ", error);
      }
    };

    fetchMovies();
  }, []);

  return (
    <div className='list'>
        <div className='list-container'>
        <MovieReturn />

      <h1 className='head'>Fan Favorites</h1>
<ul className='Mlist'>
  {movies.map(movie => (
   <li key={movie.id} className="movie-item">
  <Link to={`/movie/${movie.id}`}>
   <div className="movie-container">
     <img className="mov" src={`${imageBaseUrl}${movie.poster_path}`} alt={movie.title} />
     <div className='Mname'>{movie.title}</div>
   </div>
  </Link>

 </li>
  ))}
</ul>
      </div>
    </div>
  );
};

export default MovieList;
